<template>
  <b-button
    variant="primary"
    :class="`button-add-another tw-bg-[#387DFF] tw-py-[15px] tw-px-[25px] tw-rounded-md tw-w-full ${props.styleButton}`"
  >
    <span :class="['tw-flex tw-justify-between tw-items-center']">
      <span :class="['tw-text-[#FFFFFF] tw-text-[14px] tw-font-semibold']">
        <slot>
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-domain-add-another-button-1",
            )
          }}
        </slot>
      </span>
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-min-w-[28px] tw-min-h-[28px] tw-bg-[#FFFFFF] tw-rounded-[50%]"
      >
        <span
          class="tw-text-[#387DFF] tw-text-base tw-font-medium tw-mt-[3px] tw-ml-[1px]"
          >+</span
        >
      </div>
    </span>
  </b-button>
</template>
<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";

const props = defineProps({
  styleButton: {
    type: String,
    required: false,
    default: "",
  },
});
</script>
